<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 19:01:20
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-24 15:41:16
 * @Description: 
 * @FilePath: /weryai-web/components/CreateNew.vue
-->
<template>
    <div class="relative flex justify-center">
        <button
            class="create-btn w-full min-w-[136px] h-[48px] px-[10px] py-[14px] mb-[10px] flex items-center justify-center text-white transition-all duration-300"
            @click="toggleModal">
            <img src="~/assets/images/common/add.svg" alt="add" class="w-5 h-5" />
            {{ t('menus.Creation') }}
        </button>

        <div v-if="showModal"
            class="fixed top-[120px] left-[20px] bg-popup-default rounded-[10px] p-4 shadow-lg z-[99999] min-w-[460px] max-w-[460px] overflow-hidden"
            @click.stop>
            <div class="grid grid-cols-3 gap-4 overflow-hidden">
                <div>
                    <h3 class="text-text-adad text-sm mb-3">
                        {{ t('menus.createModal.video') }}
                    </h3>
                    <nav class="flex flex-col items-center justify-center gap-1">
                        <NuxtLink v-for="item in videosRouterEnums" :key="item.path"
                            :class="{ 'text-text-active': route.path === item.path }"
                            class="w-full h-10 flex items-center justify-start gap-1 hover:text-text-active transition-all duration-300"
                            :to="item.path">
                            <span class="w-4 h-4" :class="item.icon"></span>
                            <span class="line-clamp-1 text-sm">{{
                                item.name
                            }}</span>
                        </NuxtLink>
                    </nav>
                </div>

                <div>
                    <h3 class="text-text-adad text-sm mb-3">
                        {{ t('menus.createModal.image') }}
                    </h3>
                    <nav class="flex flex-col items-center justify-center gap-1">
                        <NuxtLink v-for="item in imagesRouterEnums" :key="item.path"
                            :class="{ 'text-text-active': route.path === item.path }"
                            class="w-full h-10 flex items-center justify-start gap-1 hover:text-text-active transition-all duration-300"
                            :to="item.path">
                            <span class="w-4 h-4" :class="item.icon"></span>
                            <span class="line-clamp-1 text-sm">{{
                                item.name
                            }}</span>
                        </NuxtLink>
                    </nav>
                </div>

                <div>
                    <h3 class="text-text-adad text-sm mb-3">
                        {{ t('menus.createModal.music') }}
                    </h3>
                    <nav class="flex flex-col items-center justify-center gap-1">
                        <NuxtLink v-for="item in musicsRouterEnums" :key="item.path"
                            :class="{ 'text-text-active': route.path === item.path }"
                            class="w-full h-10 flex items-center justify-start gap-1 hover:text-text-active transition-all duration-300"
                            :to="item.path">
                            <span class="w-4 h-4" :class="item.icon"></span>
                            <span class="line-clamp-1 text-sm">{{
                                item.name
                            }}</span>
                        </NuxtLink>
                    </nav>
                </div>
            </div>
        </div>

        <div v-if="showModal" class="fixed inset-0 z-[99998]" @click="closeModal"></div>
    </div>
</template>
<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useI18n } from '~/composables/useI18n'
import { useToolsHooks } from '@/utils/useHooks'

const route = useRoute()
const appStore = useAppStore()
const { videosRouterEnums, imagesRouterEnums, musicsRouterEnums } = useToolsHooks()

const { t } = useI18n()
const showModal = ref(false)


const toggleModal = () => {
    showModal.value = !showModal.value
}

const closeModal = () => {
    showModal.value = false
}

// 监听 ESC 键关闭弹窗
const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
        closeModal()
    }
}

watch(() => route.path, (newVal) => {
    if (newVal) {
        showModal.value = false
        appStore.setToolSidebarOpen(false)

    }
})

onMounted(() => {
    document.addEventListener('keydown', handleKeydown)
})

onUnmounted(() => {
    document.removeEventListener('keydown', handleKeydown)
})
</script>
<style scoped lang="less">
.create-btn {
    border-radius: 10px;
    border: 1px solid var(--weryai-text-active);
    background: rgba(0, 0, 0, 0.15);
}
</style>
